import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import {TimelineMax} from 'gsap';







ReactDOM.render(
  <App />,
  document.getElementById('root')
);
function init()
{
const hamburger=document.querySelector('.menu');
const navOpen=document.querySelector('.nav-open');
const contact=document.querySelector('.contact');

const tl= new TimelineMax({paused: true, reversed: true});
tl.to(navOpen,0.5,{y:0})
.fromTo(contact,0.5,{opacity:0,y:10},{opacity:1,y:0},'-=0.1');
hamburger.addEventListener('click',() => {
    tl.reversed() ? tl.play() : tl.reverse();
});
}

init();



// WEBPACK FOOTER //
// ./src/index.js